import React, { useContext } from "react";
import _ from "lodash";
import "react-circular-progressbar/dist/styles.css";
import Protection from "components/Protection"
import classNames from "lib/classNames";
import {
  VARIANTS
} from 'lib/globals'

import ShopContext from "context/ShopContext";

const Preview = ({openTooltip= false}) => {
  

  const shopContext = useContext(ShopContext);
  const { 
    settings
   } = shopContext.state;

  const product = {
    variants: VARIANTS
  }
  return <div  className={classNames( "shadow text-gray-800 mb-4 p-4 rounded-lg bg-white text-black" )}>
      <Protection settings={settings} product={product} isPreview={true} openTooltip={openTooltip}/>
    </div>;
};



export default Preview;


